import type { Provider } from '../../lib/auth';

type Props = {
  provider: Provider;
  onClick: () => void;
  disabled?: boolean;
  accent: string;
};

export function SsoButton({ provider, onClick, disabled, accent }: Props) {
  const isMs = provider === 'microsoft';
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        height: 54,
        width: '100%',
        borderRadius: 8,
        background: 'var(--ink)',
        color: '#fff',
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.35 : 1,
        fontFamily: 'inherit',
        fontWeight: 500,
        fontSize: 15,
        letterSpacing: '-0.005em',
        transition: 'transform .15s, box-shadow .15s',
        boxShadow: disabled ? 'none' : '0 1px 0 rgba(0,0,0,.04)',
      }}
      onMouseEnter={(e) => {
        if (!disabled) e.currentTarget.style.boxShadow = `0 0 0 3px ${accent}33`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = '0 1px 0 rgba(0,0,0,.04)';
      }}
    >
      {isMs ? (
        <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden>
          <rect x="1" y="1" width="7.5" height="7.5" fill="#F25022" />
          <rect x="9.5" y="1" width="7.5" height="7.5" fill="#7FBA00" />
          <rect x="1" y="9.5" width="7.5" height="7.5" fill="#00A4EF" />
          <rect x="9.5" y="9.5" width="7.5" height="7.5" fill="#FFB900" />
        </svg>
      ) : (
        <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden>
          <path
            fill="#4285F4"
            d="M17.6 9.2c0-.6-.05-1.18-.16-1.74H9v3.3h4.84a4.14 4.14 0 0 1-1.79 2.71v2.26h2.9c1.7-1.57 2.65-3.87 2.65-6.53z"
          />
          <path
            fill="#34A853"
            d="M9 18c2.43 0 4.47-.81 5.95-2.18l-2.9-2.26c-.8.54-1.83.86-3.05.86-2.34 0-4.32-1.58-5.03-3.71H.97v2.33A8.99 8.99 0 0 0 9 18z"
          />
          <path
            fill="#FBBC05"
            d="M3.97 10.71A5.42 5.42 0 0 1 3.68 9c0-.59.1-1.17.29-1.71V4.96H.97A8.99 8.99 0 0 0 0 9c0 1.45.35 2.83.97 4.04l3-2.33z"
          />
          <path
            fill="#EA4335"
            d="M9 3.58c1.32 0 2.5.46 3.44 1.34l2.58-2.58C13.46.89 11.43 0 9 0A8.99 8.99 0 0 0 .97 4.96l3 2.33C4.68 5.16 6.66 3.58 9 3.58z"
          />
        </svg>
      )}
      Continue with {isMs ? 'Microsoft' : 'Google'}
    </button>
  );
}
